import { Alert, Card } from "flowbite-react";
import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import HistoricoConsultas from "../../common/query/HistoricoConsultas";
import { getColorScore, getImageURLScore } from "../../../utils/utils";

const PendenciasSerasaQuery = ({ data }) => {
  return (
    <>
      <div>
        {data?.statusRetorno == 1 ? (
          <>
            <TitleStripe>Score</TitleStripe>
            <div className="grid grid-cols-2 gap-4 mt-4 items-center">
              <div>
                <div className="pt-2 px-14 pb-0">
                  <img src={getImageURLScore(data?.score?.score)} />
                </div>
                <div
                  className="font-semibold text-lg rounded p-2 w-fit mb-4 text-white  mx-auto mt-4"
                  style={{
                    background: `${getColorScore(data?.score?.score)}`,
                  }}
                >
                  Score {data?.score?.score}
                </div>
              </div>
              <div className="bg-gray-100 rounded-md p-2 border border-gray-300">
                {data?.score?.mensagem}
              </div>
            </div>
            <TitleStripe>Pendências Financeiras - Base I</TitleStripe>
            {data?.pendenciasFinanceiras?.length > 0 ? (
              <PendenciasFinanceiras
                pendenciasFinanceiras={data?.pendenciasFinanceiras}
              />
            ) : (
              <NoOcurrence />
            )}

            <TitleStripe>Pendências Financeiras - Base II</TitleStripe>
            {data?.pendenciasFinanceiras?.length > 0 ? (
              <PendenciasFinanceiras
                pendenciasFinanceiras={data?.pendenciasFinanceiras}
              />
            ) : (
              <NoOcurrence />
            )}

            <TitleStripe>Histórico consultas</TitleStripe>
            {data?.historicoConsultas?.length > 0 ? (
              <HistoricoConsultas
                historicoConsultas={data?.historicoConsultas}
              />
            ) : (
              <NoOcurrence />
            )}
          </>
        ) : (
          <div>
            <TitleStripe>Pendências Financeiras</TitleStripe>
            <Alert withBorderAccent color="gray" className="mt-4">
              Consulta Indisponível no momento
            </Alert>
          </div>
        )}
      </div>
    </>
  );
};

export default PendenciasSerasaQuery;
